import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { SipTransportProtocol } from './sip-transport-protocol.enum';

@Api('api/agentic-cx/outbound-number')
export class OutboundNumberDto extends DtoHasApi {
  id?: number;
  phoneNumber!: string;
  gatewayUsername?: string;
  gatewayPassword?: string;
  gatewayRealm?: string;
  gatewayRegister!: boolean;
  protocol?: SipTransportProtocol;
  isDefault!: boolean;
  isActive?: boolean;
}
